import React from "react";
import { Event, RoomChatMessagePayload } from "@uno/protocol";
import { AppContext } from "context";
import useStoreRoomChat from "store/useStoreRoomChat";

const useRoomChatListener = () => {
    const { socket } = React.useContext(AppContext);

    React.useEffect(() => {
        if(!socket) {
            return;
        }

        const handler = (payload: RoomChatMessagePayload) => {
            useStoreRoomChat.getState().push({
                playerId: payload.playerId,
                username: payload.username,
                avatar: payload.avatar,
                text: payload.text,
            });
        };

        const typingHandler = (payload: { playerId: string }) => {
            useStoreRoomChat.getState().setTyping(payload.playerId);
        };

        socket.on(Event.RoomChatMessageReceived, handler);
        socket.on(Event.RoomChatTypingReceived, typingHandler);

        return () => {
            socket.off(Event.RoomChatMessageReceived, handler);
            socket.off(Event.RoomChatTypingReceived, typingHandler);
        };
    }, [socket]);
};

export default useRoomChatListener;
